import PropTypes from 'prop-types'
import React from 'react'

import { ButtonSmall } from 'react-wot-bootstrap'

import {
    EMPTY_LIST_TITLE,
    UPDATE_BUTTON_CAPTION,
} from './constants'


import styles from './EmptyList.scss'

const EmptyList = (props) => {
    return (
        <div className={styles.base}>
            <div className={styles.holder}>
                <h3 className={styles.title}>{EMPTY_LIST_TITLE}</h3>
                <div className={styles.button}>
                    <ButtonSmall
                        onClick={props.handleListUpdate}
                        type='secondary'
                        isDisabled={props.updateCooldown}
                    >
                        {UPDATE_BUTTON_CAPTION}
                    </ButtonSmall>
                </div>
            </div>
        </div>
    )
}

EmptyList.propTypes = {
    updateCooldown: PropTypes.bool,
    handleListUpdate: PropTypes.func.isRequired,
}

export default EmptyList



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitsList/components/EmptyList/EmptyList.jsx